<template>
  <section class="preview">
    <form novalidate @submit.prevent="crear">
        <div class="form-group mb-4">
            <label class="typo__label">
            Promocion
            </label>
            <multiselect
            v-model="promotion_id"
            tag-placeholder="Add this as new Partner"
            placeholder="Seleccione un Partner"
            label="name"
            track-by="id"
            :options="promotions"
            :multiple="false"
            :taggable="true"
            ></multiselect>
        </div>
        <div class="form-group mb-4">
            <label class="typo__label">
            Partner
            </label>
            <multiselect
            v-model="partner_id"
            tag-placeholder="Add this as new Partner"
            placeholder="Seleccione un Partner"
            label="name"
            track-by="id"
            :options="partners"
            :multiple="false"
            :taggable="true"
            ></multiselect>
        </div>
        <div class="form-group mb-4" v-if="partner_id.id">
          <label class="typo__label">Página</label>
          <multiselect
            v-model="page_id"
            placeholder="Seleccione la página"
            label="name"
            track-by="id"
            :options="pages"
            :multiple="false"
          ></multiselect>
        </div>
        <div class="form-group mb-4">
            <label class="typo__label">
            ¿Cómo quieres hacer la segmentación de ubicación?
            </label>
            <multiselect
            v-model="geo_based_in"
            label="name"
            track-by="id"
            :options="geos"
            :multiple="false"
            :taggable="true"
            ></multiselect>
        </div>
         <mdb-input
            label="Nombre de campaña"
            class="mb-4 mt-0"
            v-model="name"
            required
            invalidFeedback="Coloca el nombre"
        ></mdb-input>
        <div class="form-group mb-4">
            <label class="typo__label">Cuenta de usuario</label>
            <multiselect
              v-model="account_id"
              @select="getPixels"
              tag-placeholder="Agrega nueva página"
              placeholder="Seleccione la página"
              label="name"
              track-by="id"
              :options="accounts"
              :multiple="false"
            ></multiselect>
        </div>
        <div class="form-group mb-4">
            <label class="typo__label">App</label>
            <multiselect
              v-model="app_id"
              tag-placeholder="Agrega nueva página"
              placeholder="Seleccione la página"
              label="name"
              track-by="id"
              :options="apps"
              :multiple="false"
            ></multiselect>
        </div>
        <div class="form-group mb-4" v-if="account_id.id">
            <label class="typo__label">Pixel</label>
            <multiselect
              v-model="pixel_id"
              placeholder="Seleccione el pixel"
              label="pixel_code"
              track-by="id"
              :options="pixels"
              :multiple="false"
            ></multiselect>
        </div>
        <div class="form-group mb-4" >
             <label class="typo__label">
                Línea de contenido
              </label>
              <multiselect
                v-model="content_line_id"
                placeholder="Seleccione el pixel"
                label="name"
                track-by="id"
                :options="lines"
                :multiple="false"
              ></multiselect>
        </div>
        <div class="form-group mb-4" >
             <label class="typo__label">
                Proposito
              </label>
              <multiselect
                v-model="proposal_id"
                placeholder="Seleccione el pixel"
                label="name"
                track-by="id"
                :options="proposals"
                :multiple="false"
              ></multiselect>
        </div>
        <div class="form-group mb-4">
            <label class="typo__label">
            Objetivo de campaña
            <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">
                Es importante que sepas qué quieres conseguir para que elijas el
                objetivo adecuado. Tu objetivo publicitario es lo que quieres que
                hagan las personas cuando vean tus anuncios
                </span>
                <mdb-btn slot="reference" class="boton-pregunta">
                <mdb-icon class="icono-crear" icon="question-circle" />
                </mdb-btn>
            </mdb-tooltip>
            </label>
            <multiselect
            v-model="objective_id"
            placeholder="Objetivo de campaña"
            label="name"
            track-by="code"
            :options="objectives"
            :multiple="false"
            ></multiselect>
        </div>
        <div class="form-group mb-4">
            <label class="typo__label">Estatus</label>
            <multiselect
            v-model="status"
            label="name"
            track-by="id"
            :options="status_options"
            :multiple="false"
            ></multiselect>
        </div>

        <div class="form-group mb-4">
          <label>Fecha inicio</label>
          <datetime type="datetime" input-id="fecha-input" format="yyyy-MM-DD hh:mm:ss" v-model="start_date"></datetime>
        </div>

        <div class="form-group mb-4">
          <label>Fecha fin</label>
          <datetime type="datetime" input-id="fecha-input" format="yyyy-MM-DD hh:mm:ss" v-model="end_date"></datetime>
        </div>
        
        <div class="form-group mb-4">
            <label class="typo__label">Estrategias de acción </label>
            <multiselect
            v-model="bid_strategy"
            label="name"
            track-by="id"
            :options="bidStrategys"
            :multiple="false"
            ></multiselect>
        </div>

        <div class="form-group mb-4">
            <label class="typo__label">
            Presupuesto completo 
            </label>
            <input
            type="number"
            step="0.01"
            class="form-control"
            placeholder="Presupuesto diario"
            v-model="lifetime_budget"
            autocomplete="false"
            />
        </div>

        <div class="form-group mb-4">
            <label class="typo__label">
            Presupuesto Diario
            <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">
                Facebook intentará gastar todo el presupuesto y obtener el mayor número de clicks
                en el enlace aplicando la estrategia de puja de menor coste.
                </span>
                <mdb-btn slot="reference" class="boton-pregunta">
                <mdb-icon class="icono-crear" icon="question-circle" />
                </mdb-btn>
            </mdb-tooltip>
            </label>
            <input
            type="number"
            step="0.01"
            class="form-control"
            placeholder="Presupuesto diario"
            v-model="daily_budget"
            autocomplete="false"
            />
        </div>
      <div class="text-center">
        <mdb-btn type="submit" color="primary" :disabled="isLoading">
          <span v-if="!isLoading">Crear</span>
          <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoading"></semipolar-spinner>
        </mdb-btn>
      </div>
    </form>
  </section>
</template>



<script>
import { SemipolarSpinner } from "epic-spinners";

import Multiselect from "vue-multiselect";
import store from "../../store";
import { Datetime } from 'vue-datetime';
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbTooltip
} from "mdbvue";
export default {
  name: "modal-2",
  components: {
    Multiselect,
    Datetime,
    SemipolarSpinner,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput,
    mdbTooltip
  },
  props: {
    onClick: Function
  },
  data: () => {
    return {
      isLoading: false,
      is_value_based:false,
      promotions:[],
      promotion_id:{},
      partners: [],
      partner_id:{},
      pixel_id:{},
      pixels:[],
      lines:[],
      apps:[],
      app_id:{},
      content_line_id:{},
      proposals:[],
      proposal_id:{},
      page_id:{},
      pages:[],
      geo_based_in:{},
      name:'',
      accounts:[],
      account_id:{},
      objective_id:{},
      objectives:[],
      geos:[
        {id:"ideology", name:"Geográficos"},
        {id:"state", name:"Provincias"},
        {id:"both", name:"Ambas"},
        {id:"none", name:"Ninguna"}
      ],
      status:{},
      status_options:[
            {id:"ACTIVE", name:"Activa"},
            {id:"PAUSED", name:"Pausada"},
            {id:"DELETED", name:"Eliminada"},
            {id:"ARCHIVED", name:"Archivada"}
      ],
      bidStrategys: [
        { name: "Menor costo sin límite", id: "LOWEST_COST_WITHOUT_CAP" },
        { name: "Menor costo con límite", id: "LOWEST_COST_WITH_BID_CAP"},
        { name: "Costo por objetivo", id:"TARGET_COST" },
        { name: "cost cap", id: "COST_CAP", },
        { name: "Lowest cost with min roas", id: "LOWEST_COST_WITH_MIN_ROAS"}
      ],
      bid_strategy:{},
      daily_budget:0,
      lifetime_budget:0,
      start_date: '',
      end_date: '',
    };
  },
  async mounted() {
      await this.getPromotions();
      await this.getPartners();
      await this.getUserAccounts();
      await this.getObjectives();
      await this.getLines();
      await this.getProposals();
      await this.getPages();
      await this.getApps();
  },
  methods: {
    async getPromotions(){
        var promotions = store.getters.getPromotions;
        if (promotions.length == 0) {
            this.isLoading = true;
            await store.dispatch("getPromotions").then(() => {
                this.isLoading = false
                promotions = store.getters.getPromotions;
                this.promotions = promotions;
                return;
            });
        } else {
            this.promotions = promotions;
            return;
        }
    },
     async getProposals(){
        var proposals = store.getters.getProposals;
        if (proposals.length == 0) {
            this.isLoading = true;
            await store.dispatch("getProposals").then(() => {
                this.isLoading = false
                proposals = store.getters.getProposals;
                this.proposals = proposals;
                return;
            });
        } else {
            this.proposals = proposals;
            return;
        }
    },
    async getPartners(){
        var partners = store.getters.getPartners;
        if (partners.length == 0) {
            this.isLoading = true;
            await store.dispatch("getPartners").then(() => {
                this.isLoading = false
                partners = store.getters.getPartners;
                this.partners = partners;
                return;
            });
        } else {
            this.partners = partners;
            return;
        }
    },
    async getUserAccounts(){
      var accounts = store.getters.getUserAccounts;
      if (accounts.length == 0) {
        this.isLoading = true;
        await store.dispatch("getUserAccounts").then(() => {
          this.isLoading = false;
          accounts = store.getters.getUserAccounts;
          this.accounts = accounts;
          return;
        });
      } else {
        this.accounts = accounts;
        return;
      }
    },
    async getObjectives(){
      var objectives = store.getters.getCampaignObjetives;
      if (objectives.length == 0) {
        this.isLoading = true;
        await store.dispatch("getCampaignObjetives").then(() => {
          this.isLoading = false;
          objectives = store.getters.getCampaignObjetives;
          this.objectives = objectives;
          return;
        });
      } else {
        this.objectives = objectives;
        return;
      }
    },
    async getLines(){
      var lines = store.getters.getLines;
      if (lines.length == 0) {
        this.isLoading = true;
        await store.dispatch("getLines").then(() => {
          lines = store.getters.getLines;
          this.lines = lines;
          return;
        });
      } else {
        this.lines = lines;
        return;
      }
    },
    async getPixels(account) {
      const id = account.id
      await store.dispatch("getAllPixels",id).then(() => {
        var pixels = store.getters.getAllPixels;
        var pixels_account = [];
        pixels.map(pixel=>{
          pixel.account_ids.map(acc=>{
            if(acc.id == id){
              pixels_account.push(pixel)
            }
          })
        })
        this.pixels = pixels;
        return;
      }); 
    },
    async getPages() {
      var pages = store.getters.getFacebookPages;
      if (pages.length == 0) {
        await store.dispatch("getFacebookPages").then(() => {
          pages = store.getters.getFacebookPages;
          this.pages = pages;
          return;
        });
      } else {
        this.pages = pages;
        return;
      }
    },
    async getApps(){
      var apps = store.getters.getApps;
      if (apps.length == 0) {
        await store.dispatch("getApps").then(() => {
          apps = store.getters.getApps;
          this.apps = apps;
          return;
        });
      } else {
        this.apps = apps;
        return;
      }
    },
    async crear(){
        const {
            promotion_id,
            pixel_id,
            proposal_id,
            account_id,
            partner_id,
            page_id,
            geo_based_in,
            name,
            objective_id,
            status,
            bid_strategy,
            daily_budget,
            lifetime_budget,
            start_date,
            end_date,
            app_id
        } = this;
        var campaign = {
            promotion_id,
            pixel_id,
            proposal_id,
            account_id,
            partner_id,
            page_id,
            geo_based_in,
            name,
            objective_id,
            status,
            bid_strategy,
            daily_budget,
            lifetime_budget,
            start_date,
            end_date,
            app_id,
        };
        store.dispatch("newCampaign", campaign).then(() => {
          this.name=""
          this.onClick();
          this.isLoading = false;
        });
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
input#fecha-input {
    width: 100%;
    height: 40px;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 10px;
}
</style>


